import React from 'react'
import { ContextMenuProps } from './types'
import { ContextMenu as StyledContextMenu, ContextMenuItem } from '../styled'

const ContextMenu: React.FC<ContextMenuProps> = ({
  contextMenu,
  onAddVertex,
  onRemoveVertex,
}) => {
  if (!contextMenu) return null

  return (
    <StyledContextMenu x={contextMenu.x} y={contextMenu.y}>
      {contextMenu.edgePoint ? (
        // Right-clicked on edge - offer to add vertex
        <ContextMenuItem
          onClick={() => {
            onAddVertex(
              contextMenu.elementId,
              contextMenu.vertexIndex!,
              contextMenu.edgePoint!,
            )
          }}>
          ➕ Add Vertex Here
        </ContextMenuItem>
      ) : contextMenu.vertexIndex !== undefined ? (
        // Right-clicked on vertex - offer to remove
        <ContextMenuItem
          onClick={() =>
            onRemoveVertex(contextMenu.elementId, contextMenu.vertexIndex!)
          }>
          ➖ Remove Vertex
        </ContextMenuItem>
      ) : null}
    </StyledContextMenu>
  )
}

export { ContextMenu }
